/**
 * UK GSLP - UK GSCC Landing Portal
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SortDirectionType = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type SortDirectionType = typeof SortDirectionType[keyof typeof SortDirectionType];

